import type { NahledyudajuPppAdresaDto } from '@gov-nx/api';

export const formatPppAddress = (
	address?: NahledyudajuPppAdresaDto
): string => {
	if (!address) return '';
	const {
		ulice,
		cisloPopisne,
		cisloEvidencni,
		cisloOrijentacni,
		castObce,
		obec,
		psc,
	} = address;

	const hlavniCislo = cisloPopisne || cisloEvidencni || '';
	const cislo = [hlavniCislo, cisloOrijentacni].filter(Boolean).join('/');
	const uliceCislo = [ulice, cislo].filter(Boolean).join(' ').trim();
	const pscObec = [psc, obec].filter(Boolean).join(' ').trim();

	return [uliceCislo, castObce, pscObec].filter(Boolean).join(', ');
};
